/* eslint-disable import/no-default-export */
import React from 'react';
import ReactDOM from 'react-dom';

export default function bulkHoldRequestLauncher({
    environment,
    itemIds,
    conversationIds,
    userId,
    onSuccess,
    onError,
}) {
    const modalContainer = document.createElement('div');
    import(
        /* webpackChunkName: "bulkHoldRequestModal" */
        '../src/HoldRequestModal/BulkHoldRequest'
    ).then(mod => {
        const { components, helpers } = mod;

        const { BulkHoldRequest, IntlProvider } = components;
        const { serverVars } = helpers;

        const rendererProps = {
            environment,
            userId,
            itemIds,
            conversationIds,
            onSuccess,
            onError,
        };

        ReactDOM.render(
            <IntlProvider
                locale={serverVars.get('locale') || 'en'}
                messages={serverVars.get('messages')}
            >
                <BulkHoldRequest {...rendererProps} openOnRender />
            </IntlProvider>,
            modalContainer
        );
    });
}
